import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogSize } from '@bo-client/shared/constants/mat-dialog-size';
import {
  AnswerDisplayAndSelectModel,
  AnswerModalTypeEnum,
  DisplayAndSelectModel
} from '@bo-client/shared/components/display-and-selec-option/display-and-select.model';
import { Subject } from 'rxjs';
import { DisplayAndSelectService } from '@bo-client/shared/components/display-and-selec-option/display-and-select.service';
import { SelectOptionModalComponent } from '@bo-client/shared/components/display-and-selec-option/select-option-modal/select-option-modal.component';

@Component({
  selector: 'app-display-and-select-option',
  templateUrl: './display-and-select-option.component.html',
  styleUrls: ['./display-and-select-option.component.scss']
})
export class DisplayAndSelectOptionComponent implements OnInit {
  @Input() options: DisplayAndSelectModel[];
  @Input() error: boolean;
  @Input() disable = false;
  @Input() columns = 3;
  @Input() title = '';
  @Input() article = '';
  @Input() selectedOption: DisplayAndSelectModel = null;
  @Input() canUpdate = false;
  @Output() onSelectedOptionChanged: EventEmitter<AnswerDisplayAndSelectModel> = new EventEmitter();

  private compUnsubs$ = new Subject<void>();
  private answer: AnswerDisplayAndSelectModel = new AnswerDisplayAndSelectModel();

  constructor(public matDialog: MatDialog, public displayAndSelectService: DisplayAndSelectService) {}

  ngOnInit(): void {
    this.title = this.title.charAt(0).toUpperCase() + this.title.slice(1);
    this.loadData();
  }

  loadData() {}

  selectOption(selectedItem: DisplayAndSelectModel) {
    this.selectedOption = null;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'select-option-modal';
    dialogConfig.maxHeight = MatDialogSize.maxHeightLogin;
    dialogConfig.width = MatDialogSize.width;
    dialogConfig.data = {
      selectedItem: selectedItem,
      title: this.title
    };
    const modalDialog = this.matDialog
      .open(SelectOptionModalComponent, dialogConfig)
      .afterClosed()
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe((result) => {
        if (result.resultOk) {
          this.selectedOption = selectedItem;
          this.answer.action = AnswerModalTypeEnum.Selected;
          this.answer.selectedItem = selectedItem;
          this.onSelectedOptionChanged.emit(this.answer);
        }
      });
  }

  changeOption() {
    this.answer.action = AnswerModalTypeEnum.Reset;
    this.onSelectedOptionChanged.emit(this.answer);
    this.selectedOption = null;
  }

  cancel() {
    this.answer.action = AnswerModalTypeEnum.Reset;
    this.onSelectedOptionChanged.emit(this.answer);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
